import styled from 'styled-components';

export default styled.div`
	display: flex;
	justify-content: flex-start;
	width: 100%;
	align-items: flex-start;
	gap: var(--spacing-medium);

	.motif-option-text,
	.motif-select-view-value {
		font-size: 1.3rem;
	}

	.motif-form-field-select-input {
		width: 30rem;
		margin-bottom: 5rem;
	}

	.clearall {
		margin: 0 1.5rem;
		height: 4.4rem;
		align-items: center;
		display: flex;
		svg {
			fill: ${(props) => props.theme.color[`black`]};
		}
	}

	.remove-existing-domain {
		display: flex;
		align-self: center;
	}

	.motif-error-message {
		.motif-error-icon {
			width: 2rem;
			height: 2rem;
		}

		svg {
			width: 2rem;
			height: 2rem;
			max-width: 2rem;
			max-height: 2rem;
			fill: ${(props) => props.theme.color[`red600`]};
			margin: 0 0.5rem 0 0;
			vertical-align: text-bottom;
		}
	}
`;
